import { BadgeSize, BadgeSkeleton, TextSkeleton } from "shared/components";
import { FC } from "react";

export const SurveyCardSkeleton: FC = () => {
  return (
    <div className="flex h-full min-h-0 w-full min-w-0 flex-col rounded-lg border border-alpha-100 bg-content-1000-inverted shadow-xs">
      <div className="flex w-full shrink-0 items-center justify-between gap-2 border-b border-alpha-40 px-6 py-3">
        <TextSkeleton size="base" className="max-w-[72%] flex-1" />
        <div
          className="size-8 shrink-0 animate-pulse rounded-lg bg-alpha-100"
          aria-hidden
        />
      </div>
      <footer className="flex shrink-0 items-center justify-between gap-2 px-6 py-3">
        <BadgeSkeleton size={BadgeSize.BASE} className="w-[108px]" />
        <TextSkeleton size="sm" className="w-[92px]" />
      </footer>
    </div>
  );
};
